<template>
  <div v-show="isVisible">
    <div :class="['traningData', colorClass]">
      <span
        :class="{ 'clickable-link': appointment.clickable }"
        @click.stop="handleClick"
      >
        {{ appointmentTitle }}
      </span>
      <div v-html="getFormattedDescription"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appointment: {
      type: Object,
      required: true,
    },
    colorClass: {
      type: String,
      required: true,
    },
    appointmentType: {
      type: String,
      required: true,
    },
    day: {
      type: Object,
      required: true,
    },
    trainerAppointment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isVisible() {
      return this.appointment.type === this.appointmentType;
    },
    appointmentTitle() {
      return this.appointment.designationsMap[this.$locale]
        ? this.appointment.designationsMap[this.$locale]
        : this.$t("appointment_type_" + this.appointment.type.toLowerCase());
    },
    getFormattedDescription() {
      //       let language = this.$locale;
      //     if (language === "en" && this.appointment.description) {
      //     this.appointment.description = this.appointment.description.replace("Vorg_", "GB_"); // UK
      // } else if (language === "pl") {
      //     this.appointment.description = this.appointment.description.replace("Vorg_", "PL_"); // Poland
      // } else if (language === "fr") {
      //     this.appointment.description = this.appointment.description.replace("Vorg_", "FRA_"); // France
      // } else if (language === "hu") {
      //     this.appointment.description = this.appointment.description.replace("Vorg_", "HU_"); // Hungary
      // } else if (language === "es") {
      //     this.appointment.description = this.appointment.description.replace("Vorg_", "ES_"); // Spain
      // } else if (language === "ru") {
      //     this.appointment.description = this.appointment.description.replace("Vorg_", "RU_"); // Russia
      // } else if (language === "kk") {
      //     this.appointment.description = this.appointment.description.replace("Vorg_", "KZ_"); // Kazakhstan
      // } else if (language === "it") {
      //     this.appointment.description = this.appointment.description.replace("Vorg_", "IT_"); // Italy
      // } else if (language === "de") {
      //     this.appointment.description = this.appointment.description.replace("Vorg_", "DEU_"); // Germany
      // }

      return this.appointment.description;
    },
  },
  watch: {
    appointment: {
      handler(newVal) {
        console.log("Appointment changed:", newVal);
      },
      deep: true,
    },
  },
  methods: {
    handleClick() {
      if (
        this.appointment.clickable &&
        (this.appointment.type === "TRAINING_AS_TRAINER" ||
          this.appointment.type === "ROOM_BLOCKED")
      ) {
        const appointment = this.getAppointment(
          this.trainerAppointment,
          this.day.day
        );
        const route = this.$router.resolve({
          path: "/edit-training-event?trainingEventId=" + appointment.reference,
        });
        window.open(route.href, "_blank");
      }
    },
    getAppointment(trainerAppointment, day) {
      return trainerAppointment.daysWithAppointments[day - 1].appointment;
    },
  },
};
</script>

<style scoped>
/* Add necessary styles here */
</style>
